// Note: `json-valid-3k` is deprecated and will be removed in the future

function getType(val) {
  try {
    return val.constructor.name;
  } catch (err) {
    return val === null ? val : typeof val;
  }
}

/**
 * Checking for the existing of things. NOTE: null is considered non-existing by this method
 * @param val
 * @returns {boolean}
 */
function is(val) {
  return val !== undefined && val !== null;
}

/**
 * @param {boolean} val
 * @returns {boolean}
 */
function isBoolean(val) {
  return typeof val === 'boolean';
}

/**
 * @param {Number} num
 * @returns {boolean}
 */
function isNumber(num) {
  return typeof num === 'number' && isFinite(num); // eslint-disable-line
}

/**
 * @param {*} val
 * @returns {boolean}
 */
function isFunction(val) {
  return typeof val === 'function';
}

/**
 * @param {*} val
 * @param {Boolean} [checkEmpty] - optional check whether the supposed array is empty
 * @returns {Boolean}
 */
function isArray(val, checkEmpty) {
  const isArr = Array.isArray(val);
  return checkEmpty === true ? isArr && !!val.length : isArr;
}

function isString(str, checkEmpty = false) {
  const isStringType = typeof str === 'string';
  return !checkEmpty ? isStringType : isStringType && !!str.length;
}

/**
 * @param {*} val
 * @param {Boolean} [checkEmpty] - optional check whether the object has any values
 * @returns {Boolean}
 */
function isObject(val, checkEmpty) {
  try {
    const isOb = typeof val === 'object' && !Array.isArray(val) && val !== null;
    return checkEmpty === true ? isOb && !!Object.keys(val).length : isOb;
  } catch (err) {
    return false;
  }
}

/**
 * @param {Object} val
 * @param {String} [name] - optional parameter for more clarity
 * @returns {string}
 */
function textNotObject(val, name) {
  const type = getType(val);
  const middle = isString(name, true) ? `'${name}' [${type}]` : type;
  return `Param ${middle}  is not an object or is empty`;
}

/**
 * @param {Object} number of arguments
 * @param {Object} arg
 */
function checkForNumberOfArguments(number, arg) {
  if (arg.length < number) {
    throw new TypeError(
      `Failed. ${number}  arguments required, but only ${arg.length} present.`,
    );
  }
}

/**
 * Capitalize or de-capitalize a string
 * ToDo: this should be added to String.prototype
 * @param {String} string
 * @param {Boolean} [toUp]
 * @returns {String}
 */
function capitalize(string = '', toUp = true) {
  return (
    string.charAt(0)[toUp ? 'toUpperCase' : 'toLowerCase']() + string.slice(1)
  );
}

const TypeValidators = {
  Boolean: isBoolean,
  String: isString,
  Number: isNumber,
  Object: isObject,
  Array: isArray,
  Function: isFunction,
};

/**
 * @deprecated
 */
export default class Validator {
  /**
   * @param {object} cfg
   * @param {object} schema
   * @returns {boolean}
   */
  static validate(cfg, schema) {
    checkForNumberOfArguments(2, [cfg, schema]);

    if (!isObject(cfg, true)) {
      throw new Error(textNotObject(cfg, 'cfg'));
    }
    if (!isObject(schema, true)) {
      throw new Error(textNotObject(schema, 'schema'));
    }

    return Validator.doBranch(cfg, schema);
  }

  static typeError(value, type) {
    return `ERROR: Value [${JSON.stringify(
      value,
    )}] does not match type [${type}]`;
  }

  static checkArray(arr, children) {
    const clone = [];
    const { type, props } = children;
    let valid = true;

    for (let i = 0; i < arr.length; i += 1) {
      const item = arr[i];
      const typeMatch = getType(item) === type;

      if (typeMatch) {
        if (props) {
          const branch = Validator.doBranch(item, props);
          if (!branch.valid) {
            valid = false;
          }
          clone.push(branch.tree);
        } else {
          clone.push(item);
        }
      } else {
        valid = false;
        clone.push(Validator.typeError(item, type));
        break;
      }
    }

    return {
      valid,
      arr: clone,
    };
  }

  static doBranch(branch, rules = {}) {
    const tree = {};
    const keys = Object.keys(rules);
    let valid = true;

    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      const rule = rules[key];
      const { type, children } = rule;
      let item = branch[key];

      if (!is(item)) {
        if (rule.optional === true) continue; // eslint-disable-line

        if (is(rule.default)) {
          item = rule.default;
        }
      }

      const sameType = Validator.matchType(item, type);
      if (sameType) {
        if (type === 'Object') {
          const subBranch = Validator.doBranch(item, rule.props);
          if (!subBranch.valid) {
            valid = false;
          }
          tree[key] = subBranch.tree;
        } else if (type === 'Array' && children) {
          const checke = Validator.checkArray(item, children);
          if (!checke.valid) {
            valid = false;
          }
          tree[key] = checke.arr;
        } else {
          tree[key] = item;
        }
      } else {
        tree[key] = Validator.typeError(item, type);
        valid = false;
      }
    }

    return { valid, tree };
  }

  static matchType(value, type, checkEmpty = false) {
    if (value === type) return true;

    const method = TypeValidators[type];
    return method
      ? method(value, checkEmpty)
      : capitalize(typeof value) === type;
  }
}
